import LegalPage from "@/components/feature/LegalPage";

const H2 = "font-heading text-lg md:text-xl text-foreground-950 mb-3";

export default function Impressum() {
  return (
    <LegalPage
      title="Impressum"
      subtitle="Angaben gemäß § 5 TMG / § 18 Abs. 2 MStV"
    >
      <div>
        <h2 className={H2}>Anbieter</h2>
        <p>
          Financial World Vertriebs GmbH
          <br />
          Hallesche Str. 4
          <br />
          66121 Saarbrücken
          <br />
          Deutschland
        </p>
      </div>

      <div>
        <h2 className={H2}>Marke</h2>
        <p>Smile White First ist eine Marke der Financial World Vertriebs GmbH.</p>
      </div>

      <div>
        <h2 className={H2}>Vertreten durch</h2>
        <p>Geschäftsführung: Alexandra Brucker</p>
      </div>

      <div>
        <h2 className={H2}>Kontakt</h2>
        <p>
          Telefon: 0681 / 830 582 90
          <br />
          Fax: 0681 / 830 582 91
          <br />
          E-Mail:{" "}
          <a href="mailto:hv@fiwo-gmbh.de" className="text-primary-600 hover:text-primary-700 transition-colors cursor-pointer">
            hv@fiwo-gmbh.de
          </a>
        </p>
      </div>

      <div>
        <h2 className={H2}>Registereintrag</h2>
        <p>
          Eintragung im Handelsregister.
          <br />
          Registergericht: Amtsgericht Saarbrücken
          <br />
          Registernummer: HRB 17403
        </p>
      </div>

      <div>
        <h2 className={H2}>Umsatzsteuer-ID</h2>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:
          <br />
          USt-IdNr.: [USt-IdNr. ergänzen]
        </p>
      </div>

      <div>
        <h2 className={H2}>Inhaltlich Verantwortlicher</h2>
        <p>
          Inhaltlich Verantwortlicher gemäß § 10 Abs. 3 MDStV: Financial World
          Vertriebs GmbH
          <br />
          Hallesche Str. 4, 66121 Saarbrücken
        </p>
      </div>

      <div>
        <h2 className={H2}>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
        <p>
          Wir sind nicht bereit und nicht verpflichtet, an
          Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
          teilzunehmen.
        </p>
      </div>

      <div>
        <h2 className={H2}>Haftung für Inhalte</h2>
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte
          auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
          §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
          Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
          hiervon unberührt.
        </p>
      </div>

      <div>
        <h2 className={H2}>Haftung für Links</h2>
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
          fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
          verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
          Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
          Verlinkung auf mögliche Rechtsverstöße überprüft.
        </p>
      </div>

      <div>
        <h2 className={H2}>Urheberrecht</h2>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
          Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
          Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
          Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
          jeweiligen Autors bzw. Erstellers.
        </p>
      </div>
    </LegalPage>
  );
}